import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

function useRecommendations ({ widget }) {

    const [hasRecommendations, setHasRecommendations] = useState(false);
    const [recommendations, setRecommendations] = useState([]);

    useEffect(() => {
        if (!isEmpty(widget) && !isEmpty(widget.recommendations)) {
            setHasRecommendations(true);
            setRecommendations(widget.recommendations);
        } else {
            setHasRecommendations(false)
            setRecommendations([]);
        }
    }, [widget]);

    function getAdUnit () {
        const src = widget.ad_units?.desktop?.medium_rectangle;
        const adUnit = {
            url: src.url,
            image: src.image,
        };

        return adUnit;
    }

    function shouldRenderAdUnit () {
        const src = widget?.ad_units?.desktop?.medium_rectangle;
        if (isEmpty(src?.url) || isEmpty(src?.image)) {
            return false;
        }
        return true;
    }

    return {
        hasRecommendations,
        recommendations,
        getAdUnit,
        shouldRenderAdUnit,
    };
}

export default useRecommendations;
